import { useLayoutEffect } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';

const useContentsScrollTop = (scrollElement) => {
  const location = useLocation();
  const navType = useNavigationType();

  useLayoutEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  useLayoutEffect(() => {
    if (navType === NavigationType.Push) {
      scrollElement ? scrollElement.scrollTo(0, 0) : document.documentElement.scrollTo(0, 0);
    }
  }, [location.pathname, navType, scrollElement]);
};

export default useContentsScrollTop;
